import { Eye, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '@/contexts/PermissionContext';

export function RolePreviewBanner() {
  const { isPreviewing, previewRole, stopPreview } = usePermissions();
  const navigate = useNavigate();

  if (!isPreviewing) return null;

  const handleExit = () => {
    stopPreview();
    navigate('/roles');
  };

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between text-sm print:hidden">
      <div className="flex items-center gap-2">
        <Eye className="h-4 w-4" />
        <span>
          Previewing role: <strong>{previewRole?.name}</strong>
        </span>
      </div>
      <button
        onClick={handleExit}
        className="flex items-center gap-1 bg-amber-600 hover:bg-amber-700 px-3 py-1 rounded text-white text-sm transition-colors"
      >
        <X className="h-3.5 w-3.5" />
        Exit Preview
      </button>
    </div>
  );
}
